module.exports = __webpack_public_path__ + "static/planet_escape_logo-7213a0cc739aa17fdde74376aebb4a69.png";